var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1225.07 709.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-4,.cls-5{fill:#fff;}.cls-1{stroke:#fe7624;}.cls-1,.cls-5,.cls-7,.cls-9{stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}.cls-2{fill:#feba92;}.cls-3{fill:#5d21d1;}.cls-5,.cls-7{stroke:#2e186a;}.cls-6{fill:#fe7624;}.cls-7,.cls-9{fill:none;}.cls-8{fill:#2e186a;}.cls-9{stroke:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "solid"
  }, /*#__PURE__*/React.createElement("g", {
    id: "support"
  }, /*#__PURE__*/React.createElement("g", {
    id: "suculent"
  }, /*#__PURE__*/React.createElement("path", {
    id: "succulent",
    className: "cls-1",
    d: "M459.1,468.56c-9.62-5.15-17.78-2.67-26.84,6.87,4.14-23.17,4-51.27-14.37-56-18.92-4.89-29.64,6.89-40.73,35.36.42-24.43-4.41-55.94-24.64-57.22-22.75-1.44-30.27,17.27-35.92,58.77-7.07-23.21-26.6-63.86-49.55-55.8-22.5,7.89-21.05,29.58-8.55,73.8-12.33-19.09-37-47.47-53.51-36.68-15.71,10.24-11.41,26.93,6,57.94-11.49-5-23.44-5.49-33,3.95-21.46,21.2-11.14,41.28,18.64,78.55s243.7-28.66,253.85-45.52S476.58,477.9,459.1,468.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pot",
    className: "cls-2",
    d: "M460.78,531.88l.17-.55-287.66.89.18.55a29.73,29.73,0,0,0-23.69,33.74l21.53,138.78,291.62-.89,21.54-138.78A29.74,29.74,0,0,0,460.78,531.88Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "woman"
  }, /*#__PURE__*/React.createElement("g", {
    id: "body"
  }, /*#__PURE__*/React.createElement("path", {
    id: "clothing",
    className: "cls-3",
    d: "M932,481.85a115.63,115.63,0,0,0-13.36.78c-23.88-33-51.29-61-80.09-78.78-75-46.19-178-33-274.13,2.59-66.07,24.45-149.82,103.17-203.52,159-70,5.26-123.81,52.91-120.58,107.42a80,80,0,0,0,9.6,33.42l234.94,1.56c.41-.63.8-1.28,1.19-1.92l348.45-1.2c.38.53.77,1,1.16,1.56l192.92-.33c17.86-23.67,28.59-54,28.59-87.12C1057.14,543.17,1001.1,481.85,932,481.85Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "clothing_lines",
    "data-name": "clothing lines"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M845.38,408.29C756.72,463.24,677,464.45,625.47,455.61c-47.82-8.2-82.26-26.65-93.53-33.82q-2.87,1.62-5.75,3.32c9.19,6.33,45.19,27.11,97.19,36.22a296.5,296.5,0,0,0,51.28,4.47,300.82,300.82,0,0,0,52.41-4.63c42-7.46,83.63-24,123.63-49.15Q848,410.1,845.38,408.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M836.19,502.88c14.1-19.8,31.54-30.93,51.85-33.09a65.54,65.54,0,0,1,22,1.37q-2.81-3.63-5.68-7.15a72.18,72.18,0,0,0-16.62-.22c-15.27,1.56-37.45,9-56.4,35.61a3,3,0,0,0,.71,4.18,3,3,0,0,0,1.74.56A3,3,0,0,0,836.19,502.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M837.27,573.16h.06a3,3,0,0,0,3-2.95c.17-8.82,3.73-28.77,16-47.58,14.24-21.85,35.19-35.32,62.24-40.09-1.31-1.8-2.63-3.6-4-5.38-27,5.5-48.85,20-63.3,42.19-12.15,18.65-16.73,39-17,50.75A3,3,0,0,0,837.27,573.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M413.58,543.59a144,144,0,0,0-33.87,2.6q-4.53,4.54-8.87,9c11.09-6.09,74.29-13.68,100.39,16a3,3,0,0,0,2.25,1,3,3,0,0,0,2-.75,3,3,0,0,0,.27-4.23C458.94,548.08,429.58,544.21,413.58,543.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M358.88,565.6l.17,0-.25,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M465,586.54c-35.34-26.66-79.29-28.25-97.93-27.54l-6.2,6.41c10.68-.87,61.85-3.26,100.51,25.92a3,3,0,1,0,3.62-4.79Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "hand",
    className: "cls-5",
    d: "M312.54,705.29s32.77-97,125.07-79.39,218.56,55.44,218.56,55.44v24.31Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "hand_II",
    "data-name": "hand II"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1041.28,347.05a16.49,16.49,0,0,1-8.35-12.24c-1-8.58,4.76-45.54,14-50.7s51.56-28.11,59.37-27.58S1117.4,324.93,1041.28,347.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1045.77,288.24c15.8-55.31,28.74-67.66,36.19-62.28,6.75,4.88-7,40.12-11,58.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand_II-2",
    "data-name": "hand II",
    className: "cls-5",
    d: "M1115.5,276.19c7.92-12.86,21-12.22,14.17,9.7-6.66,21.37-11.6,49.24-24.1,61.83s-17,18.23-17,18.23-25,93.3-39.19,170.87C1028.84,649,990.11,670.58,953.9,657.73S911,594.17,960.45,495.6s75.52-156,75.52-156"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1036.8,341.37c-7.17-4.85-6.31-33.06-14.36-45.35-10-15.32-19.78-31.2-1.27-28.82,15.87,2.05,20.92,16,24.6,21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1106.25,299.65s14.06-34.25,18.78-50.09c5.17-17.34-13-19.78-21.76,5.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1089.74,290.66s27.68-62.72,15.3-68.3c-11.29-5.09-19.9,17.79-34.11,62"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "head"
  }, /*#__PURE__*/React.createElement("path", {
    id: "neck",
    className: "cls-5",
    d: "M637,336.2l3.88,70.72s-6.57,38.16,46.44,31.09c52.8-7.05,46.32-38.31,46.32-38.31L717.3,311.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ear",
    className: "cls-5",
    d: "M737.6,222.76s41-15.38,42.6,27.32-42.6,31.64-42.6,31.64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "face",
    className: "cls-5",
    d: "M631.8,155.61h70.38a39,39,0,0,1,39,39v82.64a80.44,80.44,0,0,1-80.44,80.44h0a80.44,80.44,0,0,1-80.44-80.44V207.1a51.49,51.49,0,0,1,51.49-51.49Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "headphones"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M759.9,315.38A276.13,276.13,0,0,0,755,263.2c0-.33,0-.68,0-1a11.45,11.45,0,0,0-11.4-11.4v11.4l.3,11.4a11.37,11.37,0,0,0,6.41-2.22c3.69,23,11,91.58-19.77,149.88-5.65,10.69-10.95,20.57-16.07,30.12-29,54.12-48.2,89.87-47.75,121.8a3,3,0,0,0,3,3h0a3,3,0,0,0,3-3c-.43-30.37,18.46-65.58,47-118.88,5.13-9.55,10.43-19.44,16.08-30.15C756,385.9,760.05,343.9,759.9,315.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M572.48,274.8a11.26,11.26,0,0,0,4.57,1.41V253.53a11.4,11.4,0,0,0-10.24,9.67,3,3,0,0,0-.51,1.67c0,4.56,0,112.3,32,160.91,32.72,49.8,42.84,78.16,45.09,126.45a3,3,0,0,0,3,2.86h.14a3,3,0,0,0,2.86-3.13c-2.31-49.56-12.64-78.6-46.06-129.46C577.84,383.76,573.29,302.94,572.48,274.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "nose",
    className: "cls-7",
    d: "M636.14,229l1.06,64.85s4.78,6.9,12.47-7.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "mouth",
    className: "cls-7",
    d: "M636.14,307.64c5.84,6.83,19.56,5.71,33.16-3.18,0,0,5.3,17.37-21.09,20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "brow",
    className: "cls-7",
    d: "M661.67,208.11c.8-.2,9.35-12.53,22.48-2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "eye_II",
    "data-name": "eye II",
    className: "cls-8",
    cx: 684.15,
    cy: 248.1,
    rx: 4.97,
    ry: 7.69
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "eye",
    className: "cls-8",
    cx: 611.45,
    cy: 250.08,
    rx: 4.97,
    ry: 7.69
  }), /*#__PURE__*/React.createElement("path", {
    id: "brow_II",
    "data-name": "brow II",
    className: "cls-7",
    d: "M595.56,207.54c.8-.17,11.63-15,22.54-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "hair_shape",
    "data-name": "hair shape"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M680.79,138.13c-19.47.25-34.25,1.23-43.11,2.85h0c-71.57,16.28-60,69.32-60,69.32s35,6.67,63.49-35.51c0,0,39.13,31.93,97,44.79.93-.22,2-.51,3-.83v2.93a47.49,47.49,0,0,1,14.63-1.53c-.64-20.91-4.38-47.26-21.61-64.27C722,143.8,704,137.82,680.79,138.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M758.82,215.05c-2.28-26.38-8.58-79.33-74.67-80a340.06,340.06,0,0,0-44.4,2.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M868.67,94.59C844,24,773.94-15.71,712.22,5.88c-50.73,17.74-80,71.38-75.16,129.11,9.29-1.64,23.94-2.61,43.65-2.86,24.87-.32,44.28,6.23,57.71,19.48,19,18.79,22.86,47.35,23.42,69.53,9.19,2.49,17.65,10,18.36,28.94.07,1.92-1.61,16.6-1.2,16.55a30.78,30.78,0,0,0,4.54,16.43c6.88,11.1,20.91,18,41.72,20.42l.35,0a3,3,0,0,0,.35-6c-18.85-2.22-31.39-8.12-37.27-17.55a24.52,24.52,0,0,1-3.59-11.14c5.14,6,14,12.47,28.12,12.47a53.94,53.94,0,0,0,11.07-1.21,3,3,0,1,0-1.22-5.87c-18.19,3.78-28.35-3.15-33.58-9.33a104.08,104.08,0,0,0,12.1-3.43C863.31,239.88,893.34,165.17,868.67,94.59Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glasses"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 688.53,
    cy: 250.08,
    r: 36.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 627.25,
    y1: 249.09,
    x2: 651.13,
    y2: 249.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 720.53,
    y1: 232.31,
    x2: 741.18,
    y2: 220.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 589.46,
    cy: 250.08,
    r: 36.6
  })))), /*#__PURE__*/React.createElement("g", {
    id: "laptop"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shape",
    className: "cls-6",
    d: "M841.16,667.88H820.37L810.15,516.61a20.91,20.91,0,0,0-20.54-19.24H499.82a17.75,17.75,0,0,0-17.94,19.24l11.31,167.47a20.9,20.9,0,0,0,20.54,19.24l327.43-.42A10.84,10.84,0,0,0,852,692.06V678.72A10.84,10.84,0,0,0,841.16,667.88Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M665.22,597.4a29,29,0,0,0-15.42-8.35,9.57,9.57,0,0,0,1.68-4.62,10.39,10.39,0,0,0-8.61-11.16c-.11,0-.23,0-.34,0-1.12-4.13-3.23-10.89-5.65-13.78a3.11,3.11,0,0,0-3.76-.82,2,2,0,0,0-.39,3.2c1.59,1.9,3.53,7.82,4.74,12.33a9.28,9.28,0,0,0-4.9,7.53,10.52,10.52,0,0,0,2.84,8.06,23.24,23.24,0,0,0-5.07,2.31c-10.42,6.47-11.7,19.35-2.86,28.76s24.46,11.8,34.88,5.33S674.07,606.81,665.22,597.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M660.83,559s-15-3-17,9.49C643.87,568.51,655.66,572.74,660.83,559Z"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "line",
    className: "cls-7",
    x1: 3,
    y1: 706.26,
    x2: 1222.07,
    y2: 706.26
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.c7d29235ce7e243c41d76e6e2254e8be.svg";
export { ForwardRef as ReactComponent };